import React, { FC, useEffect, useState } from "react";
import {
  Container,
  NavWrapper
} from './styles'
import { billingService } from "../../../../api";
import { useNavigate, useParams } from "react-router-dom";
import { Button, InfoBlock, ModalVariables, Tabs, TopProgress, Typography } from "../../../../components";
import { useTranslation } from "react-i18next";
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import { icons } from "../../../../icons";
import { useUi } from "../../../../context/ui.context";
import { Route, Navigate, Routes, useLocation } from "react-router";
import { usePageTitle } from "../../../../context/navigationContext";
import Overview from './overview'




const GatewayPage:FC = ( ) => {
  const {gatewayId} = useParams()
  const {viewAlert} = useUi()
  const [t] = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const [data, setData] = useState<any>(null);
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  usePageTitle(data?.display_name ? `${t("GATEWAY")}: ${data.display_name}` : t("GATEWAY"));
  const [loading, setLoading] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('1')
  const [tabs, setTabs] = useState<any[]>( [
      {
        title:t("OVERVIEW"),
        slug:'overview',
        id:'1'
      },
      {
        title:t("AUDIT_LOGS"),
        slug:'logs',
        id:'2'
      },
    ])

  const getData = async () => {
    if(!gatewayId) return;
    try{
      const res = await billingService.getGatewayById(gatewayId)
      setData(res.data);
      setPageLoading(false);
    } catch(err:any) {

    }
  }
  useEffect(() => {
    getData()
    const interval = setInterval(() => {
      getData()
    },20000)
    return () => {
      clearInterval(interval)
    }
  },[])

  const renderData = [
    {
      title:t("ENABLED"),
      id:'1',
      value: data?.enabled ? t("YES") : t("NO"),
    },
    {
      title:t("VISIBLE_TO_USER"),
      id:'2',
      value: data?.visible_to_user ? t("YES") : t("NO"),
    },
    {
      title:t("RECURRING_PAYMENTS_ENABLED"),
      id:'3',
      value: data?.recurring_payments_enabled ? t("YES") : t("NO"),
    },
  ]
  useEffect(() => {
    const lastPathSegment = location.pathname.split('/').pop();
    tabs.forEach((item) => {
      if (lastPathSegment === item.slug) {
        setActiveTab(item.slug);
      }
    });
  }, [location]);
    
  if(pageLoading) return <TopProgress loading={pageLoading}/>

  return(
    <Container>
       <div style={{display:'flex', gap:'10px', alignItems:'center', justifyContent:'space-between'}}>
        <Typography variant="h3">{data?.display_name}</Typography>
        <div style={{display:'flex', gap:'10px'}}>
          <Button
            onClick={() => {
              navigate(`/billing/gateways/${gatewayId}/edit`)
            }}
            test_id='button-delete'
            variant='icon'
            size='display'
          >
            <img src={icons.Edit}/>
          </Button>
        </div>
      </div>
        <NavWrapper>
          <div>
            <Tabs
              tabs={tabs}
              size='display'
              blockNavigate
              location={activeTab}
              onChange={(e) => {
                navigate(`/billing/gateways/${gatewayId}/${e}`)
              }}
            />
          </div>
        </NavWrapper>
        <Routes>
          <Route path="/" element={<Navigate replace to="overview" />} /> 
          <Route path='/overview' element={<Overview data={data}/>}/>
          {/* <Route path='/clients' element={<Clients />}/> */}
          
        </Routes>
      {/* <InfoBlock
        data={renderData}
      /> */}

    </Container>
  )
}

export default GatewayPage